import Select, { StylesConfig, components } from 'react-select'
import AsyncSelect, { AsyncProps } from 'react-select/async'
import makeAnimated from 'react-select/animated'

import { ReactNode } from 'react'
import Label from './fromLabel'
import { DropdownOptionType, Option } from '../../../_config/types'
import Error from './fromError'


// type DropDownProps<OptionType> = AsyncProps<OptionType, false>;
interface props {
    async?: boolean
    label?: string
    required?: boolean
    placeholder?: string
    value?: DropdownOptionType
    isClearable?: boolean
    onChange?: (data: any) => void
    options?: Option[]
    isMulti?: boolean
    defaultValue?: Option | null
    defaultOptions?: boolean | Option[]
    error?: string 
    disabled?: boolean
    isLoading?: boolean
    info?: string
    asyncLoadOptions?: (value: string) => Promise<any[]>
    asyncFormatOptionLabel?: (option: any) => ReactNode
    customStyleOption?: StylesConfig
    className?: string
    classNamePrefix?: 'arrow' | 'arrow-sm'
    size?: 'sm' | 'md' | 'lg'
    menuPlacement?: 'auto' | 'bottom' | 'top',
    topParentStyle?: React.CSSProperties // This prop is not used in the component, but can be used to pass styles to the top parent div if needed
}
 

 
const SelectBox: React.FC<props> = ({
    async = false,
    label,
    required = false,
    placeholder = 'Select',
    options = [],
    isClearable = false,
    value = [],
    onChange = () => {},
    isMulti = false,
    defaultValue = null,
    error,
    disabled = false,
    isLoading = false,
    info,
    asyncLoadOptions,
    asyncFormatOptionLabel,
    customStyleOption = {},
    className = '',
    classNamePrefix = 'arrow',
    size = 'md',
    menuPlacement = 'auto',
    topParentStyle= {}, // This prop is not used in the component, but can be used to pass styles to the top parent div if needed
}) => {

    const defaultStyleOption: StylesConfig = {
        control: (styles) => ({
            ...styles,
            border: '1px solid #CECECE',
            minHeight: size == 'sm'?'1.7rem':'2.875rem',
            boxShadow: 'none',
            paddingLeft:size == 'sm'?'0.2rem':'0.4rem',
            borderRadius: '0.375rem',
            width:'100%',
            marginTop:'0.5rem', marginBottom:'0rem',
            //marginTop:'0rem', marginBottom:'0rem',
            ':hover': {
                border: '1px solid #d5dad4',
                boxShadow: 'none',
            },
            ':focus': {
                border: '1px solid #d5dad4',
                outline: 'none',
                boxShadow: 'none',
            },
        }),
        placeholder: (styles) => ({
            ...styles,
            fontSize: size == 'sm'?'0.667rem':'0.938rem',
            lineHeight: 1,
            fontWeight: '400',
            color: '#a1a1a1',
        }),
        singleValue: (styles) => ({
            ...styles,
            fontSize: size == 'sm'?'0.667rem':'0.938rem',
            lineHeight: 1,
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            fontWeight: '400',
            color: '#222222'
        }),
        input: (styles) => ({ ...styles, lineHeight: 1, fontSize: '0.75rem' }),
        option: (styles, { data, isDisabled, isFocused, isSelected }) => {
            return {
                ...styles,
                backgroundColor: isDisabled ? '#FCFCFC' : isFocused ? '#f5e00361' : isSelected ? '#f5e003' : '#ffffff',
                cursor: isDisabled ? 'not-allowed' : 'default',
                border: '1px solid #f4f4f4',
                fontSize: size == 'sm'?'0.667rem':'0.938rem',
                padding: size == 'sm'?'0.25rem 0.25rem':'0.5rem 0.5rem',
                lineHeight: 1.2,
                fontWeight: 'normal',
                color: isSelected ? 'black' : 'black',
            }
        },
        menuList: (styles, props) => ({
            ...styles,
            padding: 0,
        }),
        multiValue: (base) => ({
            ...base,
            borderRadius: '1.667rem',
            backgroundColor: '#EFEFEF',
        }),
        valueContainer: (base) => ({
            ...base,
            maxHeight: '5.125rem',
            overflowY: 'scroll',
        }),
        multiValueLabel: (base) => ({
            ...base,
            fontSize: '0.867rem',
            lineHeight: '0.867rem',
        }),
        multiValueRemove: (base) => ({
            ...base,
            color: 'black',
            cursor: 'pointer',
            ':hover': {
                color: 'red',
            },
        }),
        indicatorsContainer: (style) => ({
            ...style,
        }),
     
        dropdownIndicator: (provided) => ({
            ...provided,
            padding: '0 0.25rem',
        }),
        clearIndicator: (provided) => ({
            ...provided,
            padding: '0 0.25rem',
        }),
        indicatorSeparator: () => ({
            display: 'none', // Hide the separator
        }),
        noOptionsMessage: (styles) => ({
            ...styles,
            fontSize: '0.938rem',
            padding: '0.5rem',
            fontWeight: '400',
        }),
    }
   
    return (
        <div className={`text-[0.938rem] my-6 ${className}`} style={topParentStyle}>
            {label && <Label text={label} required={required} info={info} />}
            {async ? (
                <AsyncSelect
                    classNamePrefix={error ? `error ${classNamePrefix}` : classNamePrefix}
                    placeholder={placeholder}
                    isClearable={isClearable}
                    closeMenuOnSelect={!isMulti}
                    isMulti={isMulti}
                    menuPlacement={menuPlacement}
                    // components={{ Option }}
                    defaultOptions
                    loadOptions={asyncLoadOptions}
                    //formatOptionLabel={asyncFormatOptionLabel}
                    styles={
                        {
                            ...defaultStyleOption,
                            ...customStyleOption,
                            menu: (base) => ({
                                ...base,
                                zIndex: 9999
                            }),
                            menuPortal: (base) => ({
                                ...base,
                                zIndex: 9999
                            })
                        } as StylesConfig
                    }
                    value={value}
                    onChange={onChange}
                />
            ) : (
                <Select
                    isDisabled={disabled}
                    placeholder={placeholder}
                    classNamePrefix={error ? `error ${classNamePrefix}` : classNamePrefix}
                    closeMenuOnSelect={!isMulti}
                    isClearable={isClearable}
                    /* components={{ Option }} */
                    menuPlacement={menuPlacement}
                    defaultValue={defaultValue}
                    isMulti={isMulti}
                    options={options}
                    onChange={onChange}
                    value={value}
                    isLoading={isLoading}
                    styles={
                        {
                            ...defaultStyleOption,
                            ...customStyleOption,
                            menu: (base) => ({
                                ...base,
                                zIndex: 9999
                            }),
                            menuPortal: (base) => ({
                                ...base,
                                zIndex: 9999
                            })
                        } as StylesConfig
                    }
                    /* menuPortalTarget={document.body} */
                />
            )}
 
            {error && <Error message={error} />}
        </div>
    )
}
 
export default SelectBox
 